import { Button, Typography } from '@mui/material'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import SignupLayout from './SignupLayout'
import messages from './messages'

// Static result screens for the signup flow. The verify endpoint 302-redirects expired/consumed links
// here (/signup/expired, /signup/invalid-link); the form routes to /signup/check-email on success.

const Shell = ({ title, body, showStartAgain }: { title: string; body: string; showStartAgain?: boolean }) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  return (
    <SignupLayout>
      <Typography variant='h5' gutterBottom>
        {title}
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: showStartAgain ? 3 : 0 }}>
        {body}
      </Typography>
      {showStartAgain && (
        <Button variant='contained' onClick={() => navigate('/signup')}>
          {formatMessage(messages.startAgain)}
        </Button>
      )}
    </SignupLayout>
  )
}

export const CheckEmailScreen = () => {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const email = (location.state as { email?: string } | null)?.email ?? 'your email'
  return (
    <Shell
      title={formatMessage(messages.checkEmailTitle)}
      body={formatMessage(messages.checkEmailBody, { email })}
    />
  )
}

export const ExpiredScreen = () => {
  const { formatMessage } = useIntl()
  return <Shell title={formatMessage(messages.expiredTitle)} body={formatMessage(messages.expiredBody)} showStartAgain />
}

export const InvalidLinkScreen = () => {
  const { formatMessage } = useIntl()
  return <Shell title={formatMessage(messages.invalidTitle)} body={formatMessage(messages.invalidBody)} showStartAgain />
}
